// v2026-07-24a
(function () {

// ── SOCIAL ICONS ───────────────────────────────────────────
function hideSocialIcons() {
  document.querySelectorAll('.footer-item.footer-social, .social-icons').forEach(function(el) {
    el.style.setProperty('display', 'none', 'important');
  });
}
hideSocialIcons();
document.addEventListener('DOMContentLoaded', hideSocialIcons);
setTimeout(hideSocialIcons, 500);
setTimeout(hideSocialIcons, 3000);
var observer = new MutationObserver(hideSocialIcons);
observer.observe(document.body, { childList: true, subtree: true });

// ── CSS INJECTION ──────────────────────────────────────────
function injectLandscapeCardCSS() {
  const styleId = 'oriole-landscape-card-css';
  if (document.getElementById(styleId)) return;
  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = `
    @media (max-width: 1024px) and (max-height: 500px) and (orientation: landscape) {
      body #mem-wrapper {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        width: 100vw !important;
        height: 100dvh !important;
        display: flex !important;
        flex-direction: column !important;
        padding: 4px !important;
        box-sizing: border-box !important;
        overflow: hidden !important;
        background: #fff !important;
        z-index: 99999 !important;
        margin: 0 !important;
      }
      body #mem-grid {
        flex: 1 1 0 !important;
        min-height: 0 !important;
        display: grid !important;
        grid-template-columns: repeat(6, 1fr) !important;
        grid-template-rows: repeat(4, 1fr) !important;
        gap: 3px !important;
        width: 100% !important;
        max-width: 100% !important;
        margin: 0 !important;
        overflow: hidden !important;
      }
      body #mem-grid .memory-card,
      body #mem-grid .memory-card-inner {
        width: 100% !important;
        height: 100% !important;
        aspect-ratio: unset !important;
        min-height: 0 !important;
        max-width: 100% !important;
        max-height: 100% !important;
      }
    }
  `;
  document.head.appendChild(style);
}
injectLandscapeCardCSS();

// ── CONSTANTS ──────────────────────────────────────────────
const BACK = "https://cdn.shopify.com/s/files/1/0078/9292/files/birds-repeat-web_b67f92ef-8f92-4449-9fe4-5f74bd570d30.png?v=1781028779&bust=1";
const FRONTS = [
  "https://cdn.shopify.com/s/files/1/0078/9292/files/Memory-1.jpg?v=1782761692",
  "https://cdn.shopify.com/s/files/1/0078/9292/files/Memory-2.jpg?v=1782763360",
  "https://cdn.shopify.com/s/files/1/0078/9292/files/Memory-4.jpg?v=1782763360",
  "https://cdn.shopify.com/s/files/1/0078/9292/files/Memory-5.jpg?v=1782763360",
  "https://cdn.shopify.com/s/files/1/0078/9292/files/Memory-6.jpg?v=1782763360",
  "https://cdn.shopify.com/s/files/1/0078/9292/files/Memory-9.jpg?v=1782763360",
  "https://cdn.shopify.com/s/files/1/0078/9292/files/Memory-10.jpg?v=1782763360",
  "https://cdn.shopify.com/s/files/1/0078/9292/files/Memory-12.jpg?v=1782763360",
  "https://cdn.shopify.com/s/files/1/0078/9292/files/Memory-13.jpg?v=1782763360",
  "https://cdn.shopify.com/s/files/1/0078/9292/files/Memory-14.jpg?v=1782763360",
  "https://cdn.shopify.com/s/files/1/0078/9292/files/Memory-15.jpg?v=1782763360",
  "https://cdn.shopify.com/s/files/1/0078/9292/files/Memory-16.jpg?v=1782763360",
  "https://cdn.shopify.com/s/files/1/0078/9292/files/Memory-17.jpg?v=1782763360",
  "https://cdn.shopify.com/s/files/1/0078/9292/files/Memory-18.jpg?v=1782763360",
  "https://cdn.shopify.com/s/files/1/0078/9292/files/Memory-19.jpg?v=1782763360",
  "https://cdn.shopify.com/s/files/1/0078/9292/files/Memory-20.jpg?v=1784655618",
  "https://cdn.shopify.com/s/files/1/0078/9292/files/Memory-21.jpg?v=1782763360",
  "https://cdn.shopify.com/s/files/1/0078/9292/files/Memory-22.jpg?v=1782763360"
];

// ── LANDSCAPE DETECTION ────────────────────────────────────
function isMobileLandscape() {
  return window.matchMedia(
    '(max-width: 1024px) and (max-height: 500px) and (orientation: landscape)'
  ).matches;
}

// ── GAME STATE ─────────────────────────────────────────────
let moves = 0, pairs = 0, TOTAL = 18;
let flipped = [], locked = false;

let gameTrackingStarted = false;

function trackGameEvent(eventName, data) {
  try {
    if (window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish(eventName, data);
    }
  } catch (error) {
    // Tracking must never interrupt the game.
  }
}

// ── SHUFFLE WITH SOFT MINIMUM-DISTANCE CONSTRAINT ──────────
// Tries up to 100 times to separate pairs by Manhattan distance >= 2.
// Always falls back to plain Fisher-Yates — cards are NEVER orphaned.
function shuffle(arr) {
  const cols = 6;
  const MIN_DIST = 2;

  function fisherYates(a) {
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  function manhattan(i, j) {
    const ri = Math.floor(i / cols), ci = i % cols;
    const rj = Math.floor(j / cols), cj = j % cols;
    return Math.abs(ri - rj) + Math.abs(ci - cj);
  }

  function tooClose(a) {
    const positions = {};
    a.forEach((src, idx) => {
      if (!positions[src]) positions[src] = [];
      positions[src].push(idx);
    });
    return Object.values(positions).some(([i, j]) => manhattan(i, j) < MIN_DIST);
  }

  const doubled = [...arr, ...arr];
  let result = fisherYates([...doubled]);
  for (let attempts = 0; attempts < 100; attempts++) {
    if (!tooClose(result)) return result;
    result = fisherYates([...doubled]);
  }
  // Fallback: guaranteed complete grid, pairs just may be adjacent
  return result;
}

function updateStats() {
  document.getElementById("mem-moves").textContent = moves;
  document.getElementById("mem-pairs").textContent = pairs;
}
// ── CARD STYLES ────────────────────────────────────────────
function applyCardStyles(attempt) {
  if (!isMobileLandscape()) return;
  attempt = attempt || 0;
  var cards = document.querySelectorAll('.memory-card');
  if (cards.length < 24 && attempt < 10) {
    setTimeout(function() { applyCardStyles(attempt + 1); }, 150);
    return;
  }

  var availableH = (window.visualViewport ? window.visualViewport.height : window.innerHeight) - 40;
  var availableW = (window.visualViewport ? window.visualViewport.width : window.innerWidth) - 16;
  var cardFromH = Math.floor((availableH - 3 * 3) / 4);
  var cardFromW = Math.floor((availableW - 5 * 3) / 6);
  var cardSize = Math.min(cardFromH, cardFromW);
  document.querySelectorAll('.memory-card').forEach(function(card) {
    card.style.setProperty('width', cardSize + 'px', 'important');
    card.style.setProperty('height', cardSize + 'px', 'important');
    card.style.setProperty('min-height', '0', 'important');
  });
var grid = document.getElementById('mem-grid');
if (grid) {
  var gridWidth = cardSize * 6 + 5 * 3;
  var gridHeight = cardSize * 4 + 3 * 3;
  grid.style.setProperty('width', gridWidth + 'px', 'important');
  grid.style.setProperty('height', gridHeight + 'px', 'important');
  grid.style.setProperty('grid-template-rows', 'repeat(4, ' + cardSize + 'px)', 'important');
  grid.style.setProperty('grid-template-columns', 'repeat(6, ' + cardSize + 'px)', 'important');
  grid.style.setProperty('margin', '0 auto', 'important');
}

  document.querySelectorAll('.memory-card-inner').forEach(function(inner) {
    inner.style.setProperty('width', cardSize + 'px', 'important');
    inner.style.setProperty('height', cardSize + 'px', 'important');
  });
  document.querySelectorAll('.memory-card-front img, .memory-card-back img').forEach(function(img) {
    img.style.setProperty('object-fit', 'cover', 'important');
  });
}



// ── ORIENTATION LAYOUT ─────────────────────────────────────
function applyOrientationLayout() {
  var isLS = isMobileLandscape();

  document.querySelectorAll(
    'header, .header, .site-header, .sidebar__container-holder, ' +
    '#shopify-section-announcement-bar, #shopify-section-sidebar, ' +
    '.breadcrumb, .breadcrumbs, nav[aria-label="breadcrumb"], ' +
    '.page-header, .page-header__heading, h1.title.h0, ' +
    'h1.page-title, .main-page-title, .rte p'
  ).forEach(el => {
    el.style.setProperty('display', isLS ? 'none' : '', 'important');
  });

  const stats = document.getElementById('mem-stats');
  if (stats) stats.style.setProperty('display', isLS ? 'none' : '', 'important');

  const btnDesktop = document.getElementById('mem-new-game-desktop');
  if (btnDesktop) btnDesktop.style.setProperty('display', isLS ? 'none' : '', 'important');

  const btnMobile = document.getElementById('mem-new-game-mobile');
  if (btnMobile) {
    if (isLS) {
      btnMobile.style.setProperty('display', 'inline-block', 'important');
      btnMobile.style.setProperty('order', '2', 'important');
      btnMobile.style.setProperty('justify-self', 'center', 'important');
      btnMobile.style.setProperty('margin', '0', 'important');
      btnMobile.style.setProperty('padding', '5px 14px', 'important');
      btnMobile.style.setProperty('font-size', '9px', 'important');
      btnMobile.style.setProperty('letter-spacing', '0.12em', 'important');
      btnMobile.style.setProperty('border', '1px solid #1a1a1a', 'important');
      btnMobile.style.setProperty('background', '#fff', 'important');
      btnMobile.style.setProperty('color', '#1a1a1a', 'important');
      btnMobile.style.setProperty('font-family', "'Montserrat', sans-serif", 'important');
      btnMobile.style.setProperty('font-weight', '300', 'important');
      btnMobile.style.setProperty('text-transform', 'uppercase', 'important');
      btnMobile.style.setProperty('cursor', 'pointer', 'important');
    } else {
      btnMobile.style.setProperty('display', 'none', 'important');
      btnMobile.style.removeProperty('order');
      btnMobile.style.removeProperty('justify-self');
    }
  }

  const footer = document.getElementById('mem-footer');
  if (footer) {
    if (isLS) {
      footer.style.setProperty('display', 'grid', 'important');
      footer.style.setProperty('grid-template-columns', '1fr auto 1fr', 'important');
      footer.style.setProperty('align-items', 'center', 'important');
      footer.style.setProperty('flex-shrink', '0', 'important');
      footer.style.setProperty('padding', '3px 8px 2px', 'important');
      footer.style.setProperty('width', '100%', 'important');
      footer.style.setProperty('box-sizing', 'border-box', 'important');
   } else {
  footer.style.setProperty('display', 'none', 'important');
  footer.style.removeProperty('grid-template-columns');
  footer.style.removeProperty('width');
}

  }

  const backLink = document.getElementById('mem-back-link');
  if (backLink) {
    if (isLS) {
      backLink.style.setProperty('display', 'inline-block', 'important');
      backLink.style.setProperty('order', '1', 'important');
      backLink.style.setProperty('justify-self', 'start', 'important');
      backLink.style.setProperty('font-family', "'Montserrat', sans-serif", 'important');
      backLink.style.setProperty('font-size', '9px', 'important');
      backLink.style.setProperty('font-weight', '300', 'important');
      backLink.style.setProperty('letter-spacing', '0.12em', 'important');
      backLink.style.setProperty('text-transform', 'uppercase', 'important');
      backLink.style.setProperty('color', '#888', 'important');
      backLink.style.setProperty('text-decoration', 'none', 'important');
    } else {
  backLink.style.setProperty('display', 'none', 'important');
  backLink.style.removeProperty('order');
  backLink.style.removeProperty('justify-self');
}

  }
  if (isLS) applyCardStyles();

}


// ── BUILD GRID ─────────────────────────────────────────────
var gridBuiltOnce = false;

// Pick `count` random items from a pool without mutating the original.
function pickRandom(pool, count) {
  var copy = pool.slice();
  for (var i = copy.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var tmp = copy[i]; copy[i] = copy[j]; copy[j] = tmp;
  }
  return copy.slice(0, count);
}

function buildGrid(force) {
  var grid = document.getElementById('mem-grid');
  if (!grid) return;

  if (!force && gridBuiltOnce) {
    var now = Date.now();
    var last = parseInt(grid.dataset.lastBuild || '0');
    if (now - last < 5000) return;
  }
  grid.dataset.lastBuild = String(Date.now());
  gridBuiltOnce = true;

  var isLS = isMobileLandscape();
  var activeFronts = isLS ? pickRandom(FRONTS, 12) : FRONTS;
  TOTAL = activeFronts.length;
  document.getElementById("mem-total").textContent = TOTAL;

  moves = 0; pairs = 0; flipped = []; locked = false;
  gameTrackingStarted = false;

  document.getElementById("mem-win").classList.remove("visible");

  grid.innerHTML = '';
  grid.style.setProperty('opacity', '0', 'important');
grid.style.setProperty('visibility', 'hidden', 'important');

  shuffle(activeFronts).forEach((src) => {
    const card = document.createElement("div");
    card.className = "memory-card";
    card.dataset.src = src;
    card.innerHTML = `
      <div class="memory-card-inner">
        <div class="memory-card-back"><img src="${BACK}" alt=""></div>
        <div class="memory-card-front"><img src="${src}" alt=""></div>
      </div>`;
  card.addEventListener("click", onCardClick);
  grid.appendChild(card);
});


  // Reveal only AFTER the grid reports its real dimensions (July 19 mechanism)
  function revealGrid() {
    applyOrientationLayout();
    if (isMobileLandscape()) applyCardStyles();
    var wrapper = document.getElementById('mem-wrapper');
    if (wrapper) wrapper.style.setProperty('visibility', 'visible', 'important');
    grid.style.setProperty('visibility', 'visible', 'important');
    grid.style.setProperty('opacity', '1', 'important');
  }

  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(function() {
      if (grid.offsetWidth > 0 && grid.offsetHeight > 0) {
        ro.disconnect();
        requestAnimationFrame(revealGrid);
      }
    });
    ro.observe(grid);
    // Fallback in case the observer never fires
    setTimeout(function() { ro.disconnect(); revealGrid(); }, 400);
  } else {
    setTimeout(revealGrid, 150);
  }

}


// ── CARD CLICK ─────────────────────────────────────────────
function onCardClick() {
  if (locked || this.classList.contains("flipped") || this.classList.contains("matched")) return;

  if (!gameTrackingStarted) {
    gameTrackingStarted = true;
    trackGameEvent("oriole_game_started", {
      pair_count: TOTAL
    });
  }

  this.classList.add("flipped");

  flipped.push(this);
  if (flipped.length === 2) {
    locked = true;
    moves++;
    updateStats();
    const [a, b] = flipped;
    if (a.dataset.src === b.dataset.src) {
      a.classList.add("matched");
      b.classList.add("matched");
      pairs++;
      updateStats();
      flipped = [];
      locked = false;
if (pairs === TOTAL) {
  document.getElementById("mem-win").classList.add("visible");

  trackGameEvent("oriole_game_completed", {
    pair_count: TOTAL,
    moves: moves
  });
}


    } else {
      setTimeout(() => {
        a.classList.remove("flipped");
        b.classList.remove("flipped");
        flipped = [];
        locked = false;
      }, 2000);
    }
  }
}


// ── BUTTONS ────────────────────────────────────────────────
var btnD = document.getElementById("mem-new-game-desktop");
var btnM = document.getElementById("mem-new-game-mobile");
if (btnD) btnD.addEventListener("click", function() { buildGrid(true); });
if (btnM) btnM.addEventListener("click", function() { buildGrid(true); });

// ── ORIENTATION CHANGE ─────────────────────────────────────
var resizeTimer;
var lastOrientation = isMobileLandscape() ? 'landscape' : 'portrait';
window.addEventListener('resize', function() {
  // Hide IMMEDIATELY on any resize/rotation — before the browser paints the wrong layout
  var currentOrientation = isMobileLandscape() ? 'landscape' : 'portrait';
  if (currentOrientation !== lastOrientation) {
    var wrapper = document.getElementById('mem-wrapper');
    if (wrapper) wrapper.style.setProperty('visibility', 'hidden', 'important');
    var grid = document.getElementById('mem-grid');
    if (grid) {
      grid.style.setProperty('visibility', 'hidden', 'important');
      grid.style.setProperty('opacity', '0', 'important');
    }
    // If rotating INTO landscape, hide portrait text immediately too
    if (currentOrientation === 'landscape') {
      document.querySelectorAll(
        'header, .header, .site-header, .sidebar__container-holder, ' +
        '#shopify-section-announcement-bar, #shopify-section-sidebar, ' +
        '.breadcrumb, .breadcrumbs, nav[aria-label="breadcrumb"], ' +
        '.page-header, .page-header__heading, h1.title.h0, ' +
        'h1.page-title, .main-page-title, .rte p'
      ).forEach(function(el) {
        el.style.setProperty('display', 'none', 'important');
      });
    }
  }


  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    var newOrientation = isMobileLandscape() ? 'landscape' : 'portrait';
    if (newOrientation === lastOrientation) return;
    lastOrientation = newOrientation;
    buildGrid(true);
  }, 250);
});



// ── INIT ───────────────────────────────────────────────────
(function() {
  var initDone = false;
  function runInit() {
    if (initDone) return;
    initDone = true;
    var wrapper = document.getElementById('mem-wrapper');
    if (isMobileLandscape()) {
      setTimeout(function() { buildGrid(true); }, 400);
    } else {
  setTimeout(function() { buildGrid(true); }, 400);
}
  }
  if (document.readyState === 'complete') {
    runInit();
  } else {
    window.addEventListener('load', function onLoad() {
      window.removeEventListener('load', onLoad);
      runInit();
    });
  }
})();

})();
